import chunk from "lodash.chunk";
import * as React from "react";
import { StepType, } from "../../../shared/presets/stepper.js";
export default function useChunkedSteps(steps, currentStepIndex, numOfVisibleSteps = 8) {
    const chunkedSteps = React.useMemo(() => {
        const getVisibleSteps = (steps, currentVisibleStepIndex) => steps.map((step, index) => {
            const isActive = index === currentVisibleStepIndex;
            const isComplete = index < currentVisibleStepIndex;
            const type = isComplete
                ? StepType.complete
                : isActive
                    ? StepType.active
                    : StepType.incomplete;
            return Object.assign({ stepComponentProps: {
                    active: isActive,
                    completed: isComplete,
                }, type }, step);
        });
        if (steps.length <= numOfVisibleSteps) {
            return {
                previousSteps: [],
                visibleSteps: getVisibleSteps(steps, currentStepIndex),
                nextSteps: [],
            };
        }
        let nextSteps = [];
        let previousSteps = [];
        let visibleSteps = [];
        const chunkedArr = chunk(steps, numOfVisibleSteps);
        if (currentStepIndex > steps.length - numOfVisibleSteps) {
            visibleSteps = steps.slice(steps.length - numOfVisibleSteps, steps.length);
            previousSteps = steps.slice(0, steps.length - numOfVisibleSteps);
        }
        else {
            let chunkIndex = 0;
            visibleSteps =
                chunkedArr.find((chunk, index) => {
                    if (chunk.find((item) => item.id === steps[currentStepIndex].id)) {
                        chunkIndex = index;
                        return true;
                    }
                    return false;
                }) || [];
            previousSteps = chunkedArr.slice(0, chunkIndex).flat();
            nextSteps = chunkedArr.slice(chunkIndex + 1, chunkedArr.length).flat();
        }
        const currentVisibleStepIndex = previousSteps.length > 0 ? currentStepIndex - previousSteps.length : currentStepIndex;
        return {
            currentVisibleStepIndex,
            previousSteps,
            nextSteps,
            visibleSteps: getVisibleSteps(visibleSteps, currentVisibleStepIndex),
        };
    }, [steps, currentStepIndex, numOfVisibleSteps]);
    return chunkedSteps;
}
//# sourceMappingURL=useChunkedSteps.js.map